export interface EnteredValue {
  fieldName: string;
  fieldValues: Array<string>;
  fieldDisplayName: string;
  associatedNodeId: number;
  needsInfo: Array<number>;
  hasVisited?: boolean;
}

export class SectionCategory {
  sectionCategory: string;
  displayName: string;
  description: string;
  enteredValues: Array<EnteredValue>;

  constructor(params) {
    this.sectionCategory = params.sectionCategory;
    this.displayName = params.displayName;
    this.description = params.description;
    this.enteredValues = (params.enteredValues || []).map((enteredValue: EnteredValue) => enteredValue);
  }

  isComplete = (): boolean =>
    this.enteredValues.find((value: EnteredValue): boolean => value.needsInfo?.length > 0) == null;
}

export default class Summary {
  sectionCategories: Array<SectionCategory>;

  constructor(params) {
    this.sectionCategories = (params.sectionCategories || []).map(
      (sectionCategory: object) => new SectionCategory(sectionCategory),
    );
  }

  isSubmittable = () => {
    const incompleteCategory = this.sectionCategories.find(
      (sectionCategory: SectionCategory) => !sectionCategory.isComplete(),
    );

    return incompleteCategory == null;
  };
}

export function getIncompleteCategories(summary: Summary): Set<number> {
  return summary.sectionCategories.reduce((acc: Set<number>, val, index) => {
    if (!val.isComplete()) {
      acc.add(index);
    }
    return acc;
  }, new Set([]));
}

export function isSectionCategoryExpanded(expandedSectionCategoryIndexes: Set<number>, index: number): boolean {
  return expandedSectionCategoryIndexes.has(index);
}

export function hasAllSectionsExpanded(summary: Summary, expandedSectionCategoryIndexes: Set<number>): boolean {
  return summary && summary.sectionCategories.length === expandedSectionCategoryIndexes.size;
}

export function hasAllSectionsCollapsed(expandedSectionCategoryIndexes: Set<number>): boolean {
  return expandedSectionCategoryIndexes.size === 0;
}
